export const MESSAGE = '/messages'
export const MESSAGE_DETAILS = '/messages/:id'
